import React from "react";

const Assistance_section = ({ data }) => {
  const containsHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);
  return (
    <div className="final-section container">
      <style>{`
        .final-section {
          padding: 50px;
          display: flex;
          flex-direction: column;
          gap: 40px;
          align-items: center;
          justify-content: center;
          font-family: 'Segoe UI', sans-serif;
        }

        .card {
          background-color: #f4f7fc;
          border-radius: 20px;
          padding: 20px;
          width: 100%;
          box-shadow: 0 12px 24px rgba(0,0,0,0.08);
          text-align: center;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          animation: fadeInCard 1s ease;
        }

        .card-image-section {
          margin-top: 30px;
          display: flex;
          align-items: center;
        }

        .card-image-section img {
          border: 2px solid;
          height: 250px;
          margin-right: 20px;
        }

        @media only screen and (max-width: 990px) {
          .card-image-section {
            flex-direction: column;
            gap: 20px;
            text-align: center;
          }

          .card-image-section img {
            height: 180px;
            margin-right: 0;
          }

          .final-section {
            padding: 40px 10px;
          }
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 16px 32px rgba(0,0,0,0.1);
        }

        .card h3 {
          color: #18336c;
          margin-bottom: 15px;
        }

        .card p {
          color: #333;
        }

        @keyframes fadeInCard {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <div className="card">
        <h2>{data.heading}</h2>
        {containsHTML(data?.content) ? (
          <p dangerouslySetInnerHTML={{ __html: data?.content }} />
        ) : (
          <p>{data?.content}</p>
        )}

        {(data?.image || data?.subHeading || data?.subContent) && (
        <div className="card-image-section">
          {data?.image && (
            <img src={data.image} loading="lazy" alt="Web Assistance" />
          )}
          <div>
            {data?.subHeading && <h3>{data.subHeading}</h3>}
            {containsHTML(data?.subContent) ? (
              <p dangerouslySetInnerHTML={{ __html: data?.subContent }} />
            ) : (
              <p>{data?.subContent}</p>
            )}
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Assistance_section;
